import { createContext } from 'react';

export const RightAlignContext = createContext();
export const RightAlignProvider = RightAlignContext.Provider;
export const RightAlignConsumer = RightAlignContext.Consumer;

export const IsMobile = createContext(false);
